(function () {
  const outingPlayersSearchApp = function () {
    const url = `/users/search?by_home_course=true&event_id=${gon.event.id}`;
    const searchField = $('#modal select.search-player');

    let select2Data;

    const showOptions = function (data) {
      select2Data = data.data;
      return {
        results: data.data.map(function(elem) {
          var text;
          if (elem.full_name && elem.full_name.trim() != '')
            text = elem.full_name
          else
            text = elem.email && elem.email.trim() != '' ? elem.email : elem.phone;
          return { id: elem.id, text: text }
        })
      };
    };

    const fillInputs = function(event){
      var player = select2Data.find(elem => elem.id === event.target.value );
      const container = $(this).parent().parent().parent();
      container.find('input[name*="first_name"]').val(player.first_name);
      container.find('input[name*="last_name"]').val(player.last_name);
      container.find('input[name*="phone"]').val(player.phone);
      container.find('input[name*="email"]').val(player.email);
      container.find('select[name*="gender"]').val(player.gender).trigger('change');
    };

    searchField.select2({
      ajax: { url, delay: 400, dataType: 'json', processResults: showOptions }
    }).on('change', fillInputs);
  };

  if (typeof window !== "undefined") {
    window.outingPlayersSearchApp = outingPlayersSearchApp;
  }
})();
